
export const HOME_CONFIG = {

    // The size of each square in a desktop
    DESKTOP_SQUARE_SIZE: 400,

    // The size of each square on mobile
    MOBILE_SQUARE_SIZE: 150,

    // The size of the modal opened when we click on a square in a desktop
    DESKTOP_MODAL_SIZE: 460,

    // The size of the modal opened when we click on a square on mobile
    MOBILE_MODAL_SIZE: 300,

    // After how many seconds the grid will change direction
    CHANGE_DIRECTION_FREQUENCY_IN_SECONDS: 12,

    // The maximum inclination of the grid when the user move the mouse near the top of the page
    MAX_GRID_INCLINATION_DEG: 14,

    // The maximum horizontal distance of the square from its position in the animation at the beginning
    MAX_FIRST_ANIMATION_H_DELTA_PX: 1500,

    // The maximum vertical distance of the square from its position in the animation at the beginning
    MAX_FIRST_ANIMATION_V_DELTA_PX: 500,

    // The top navigation bar text color on desktop
    NAVBAR_COLOR_DESKTOP: "light",

    // The top navigation bar text color on mobile
    NAVBAR_COLOR_MOBILE: "dark",

    // ______________________________________________________________________________________________
    // The following are performance related parameters, used to optimize the performance of the page

    // The initial number of squares in each row
    INITIAL_HORIZONTAL_SQUARES: 7,

    // The initial number of squares in each column
    INITIAL_VERTICAL_SQUARES: 5,

    // The max number of squares in each row
    MAX_HORIZONTAL_SQUARES: 12,

    // The max number of squares in each column
    MAX_VERTICAL_SQUARES: 10,

    // The frequency (in ms) of movements of the contents' grid (the greater the slower the grid will move)
    MOVE_FREQUENCY_IN_MILLISECONDS: 75,

    // After how many seconds the system check if it has to expand the contents' grid with new contents
    EXPAND_FREQUENCY_IN_MILLISECONDS: 200,

    // The minimum mouse movement in px to check if we should change the rotation of the grid
    MIN_MOUSE_DELTA_TO_ROTATE: 3

};
